var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophyIcon = function SvgTrophyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#TrophyIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.875 28.125h-15.75a2.25 2.25 0 0 0-2.25 2.25v2.25a2.25 2.25 0 0 0 2.25 2.25h15.75a2.25 2.25 0 0 0 2.25-2.25v-2.25a2.25 2.25 0 0 0-2.25-2.25M12.375 1.125H2.66A1.535 1.535 0 0 0 1.124 2.66a16.875 16.875 0 1 0 33.75 0 1.535 1.535 0 0 0-1.535-1.535h-9.715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.823 19.236-2.614 8.89h11.25l-2.364-8.875M18.9 1.613 20.772 5.3h3.19a.874.874 0 0 1 .629 1.5l-2.934 2.878 1.623 3.727a.884.884 0 0 1-1.26 1.104L18.097 12.3l-3.922 2.21a.883.883 0 0 1-1.259-1.104l1.623-3.728-2.93-2.883a.874.874 0 0 1 .63-1.5h3.19l1.873-3.687a.9.9 0 0 1 1.598.005"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TrophyIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgTrophyIcon;